import api from './api';
import apiRoutes from '../../../api/apiRoutes';

/**
 * Fetch all agents for current user / company
 */
export const fetchAgents = async () => {

  const response = await api.get(apiRoutes.agents.list);

  return response.data;
};

/**
 * Fetch a single agent by ID
 */
export const fetchAgentById = async (agentId) => {

  const response = await api.get(
    apiRoutes.agents.detail(agentId)
  );

  return response.data;
};

/**
 * Create a new agent
 */
export const createAgent = async (payload) => {

  const response = await api.post(
    apiRoutes.agents.list,
    payload
  );

  return response.data;
};

/**
 * Update agent data
 */
export const updateAgent = async (
  agentId,
  payload
) => {

  const response = await api.patch(
    apiRoutes.agents.detail(agentId),
    payload
  );

  return response.data;
};

/**
 * Delete an agent
 */
export const deleteAgent = async (agentId) => {

  const response = await api.delete(
    apiRoutes.agents.detail(agentId)
  );

  return response.data;
};

/**
 * Fetch agent relations (owner ↔ agent)
 */
export const fetchAgentRelations = async () => {

  const response = await api.get(
    apiRoutes.agents.relations
  );

  return response.data;
};

/**
 * Create relation between owner and agent
 */
export const createAgentRelation = async (
  payload
) => {

  const response = await api.post(
    apiRoutes.agents.relations,
    payload
  );

  return response.data;
};

/**
 * Update relation between owner and agent
 */
export const updateAgentRelation = async (
  relationId,
  payload
) => {

  const response = await api.patch(
    apiRoutes.agents.relation(relationId),
    payload
  );

  return response.data;
};

/**
 * Delete relation between owner and agent
 */
export const deleteAgentRelation = async (
  relationId
) => {

  const response = await api.delete(
    apiRoutes.agents.relation(relationId)
  );

  return response.data;
};
